import { connectStateResults } from 'react-instantsearch-dom';

const AlgoliaResultsCount = connectStateResults(
  ({ searchResults, prefix = '', suffix = '' }) => {
    const totalHitsCount = searchResults?.nbHits;

    if (!totalHitsCount) {
      return null;
    }

    return `${prefix}${totalHitsCount}${suffix}`;
  }
);

AlgoliaResultsCount.displayName = 'AlgoliaResultsCount';

export default AlgoliaResultsCount;
